// The stack shell's router, built from the product's route list.
//
// THIS FILE IS REPLACED when the navigation shell is re-applied: `stack`,
// `bottom-tabs` and `sidebar` each produce their own router. Everything below
// is ours until the shell itself changes.
//
// The shape is the stack shell's: one parent (`StackShell`, an IonPage with an
// outlet) and every screen a child of it, so each navigation is a push with a
// real transition and a working back button. The children come straight from
// `PRODUCT_ROUTES`, so `router.push('/play/free')` and `{ name: 'play' }` both
// land on the same screen and the plan's paths are the app's paths.

import { createRouter, createMemoryHistory } from '@ionic/vue-router';
import { homeOutline, trophyOutline } from 'ionicons/icons';

import StackShell from './pages/StackShell.vue';
import { PRODUCT_ROUTES, DESTINATION_ROUTES, HOME_ROUTE } from './product-routes.js';

/** Where the app opens. main.js pushes this. */
export const HOME = HOME_ROUTE;

const ICONS = { title: homeOutline, results: trophyOutline };

// The app's destinations, in order. A stack shell renders no chrome from this
// list, but it is what a `bottom-tabs` or `sidebar` shell would read if this
// app were re-resolved onto one.
export const DESTINATIONS = DESTINATION_ROUTES.map((r) => ({
  name: r.id,
  label: r.label,
  path: r.path,
  icon: ICONS[r.id] ?? homeOutline,
}));

/** The name the tab and sidebar shells read. */
export const TABS = DESTINATIONS;

// `/play/:mode/:code?` becomes `play/:mode/:code?` under the shell at `/`.
const children = PRODUCT_ROUTES.map((r) => ({
  path: r.path.replace(/^\//, ''),
  name: r.id,
  component: r.component,
  props: true,
}));

export default createRouter({
  history: createMemoryHistory(),
  routes: [
    {
      path: '/',
      component: StackShell,
      children,
    },
    // Anything unrecognised opens Home rather than a blank outlet.
    { path: '/:pathMatch(.*)*', redirect: HOME },
  ],
});
